// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueFire from 'vuefire'

// Fix terrible browsers!
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

import VueAwesomeSwiper from 'vue-awesome-swiper'

import App from './App'
import router from './router'
import store from './store'
import VueAnalytics from 'vue-analytics'

import { auth, db } from './firebase'

Vue.config.productionTip = false

Vue.use(VueFire)
Vue.use(VueAwesomeSwiper)

Vue.use(VueAnalytics, {
  id: 'UA-33080266-2',
  router
})

const app = new Vue({
  data: {
    user: {},
    profile: {},
    userrep: {},
    notifications: []
  },
  router,
  store,
  template: '<App/>',
  components: { App },
  computed: {
    testMessage: function () {
      return 'hello james'
    }
  },
  beforeCreate: function () {
    auth.onAuthStateChanged(function (user) {
      if (user) {
        this.user = user
        this.$bindAsObject('profile', db.ref('users/' + user.uid))
        this.$bindAsObject('profilereg', db.ref('users-registration/' + user.uid))
        this.$bindAsObject('userrep', db.ref('user-meta/reputation/' + user.uid))
        this.$bindAsArray('notifications', db.ref('user-meta/notifications/' + user.uid).limitToLast(10))
        db.ref('.info/connected').on('value', function (snapshot) {
          if (snapshot.val()) {
            db.ref('presence/' + user.uid).onDisconnect().set(false)
            db.ref('presence/' + user.uid).set(true)
          }
        })
      }
    }.bind(this))
  },
  watch: {
    profile: function (val) {
      if (val.profileimg === 'default') {
        this.profile.profileimg = 'https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f'
      }
    },
    profilereg: function (val) {
      if (val.profileimg === 'default') {
        this.profilereg.profileimg = 'https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f'
      }
    }
  }
})

app.$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js